import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { PhonebookContactVM } from '../models';

@Injectable({ providedIn: 'root' })
export class PhonebookSidebarService {
  // ─── Sidebar open/close state ───
  private openSubject = new BehaviorSubject<boolean>(false);
  isOpen$: Observable<boolean> = this.openSubject.asObservable();

  // ─── Currently selected contact (for detail view) ───
  private selectedContactSubject = new BehaviorSubject<PhonebookContactVM | null>(null);
  selectedContact$: Observable<PhonebookContactVM | null> = this.selectedContactSubject.asObservable();

  // ─── Event: contact was picked (for pages that need it) ───
  private contactPickedSubject = new BehaviorSubject<PhonebookContactVM | null>(null);
  contactPicked$: Observable<PhonebookContactVM | null> = this.contactPickedSubject.asObservable();

  // ─── Event: a global "new contact" was requested (from anywhere, e.g. the
  // app header). The globally-mounted sidebar listens and opens the dialog. ───
  private createRequestedSubject = new Subject<void>();
  createRequested$: Observable<void> = this.createRequestedSubject.asObservable();

  get isOpen(): boolean {
    return this.openSubject.value;
  }

  // ─── Open sidebar ───
  open(): void {
    this.openSubject.next(true);
  }

  // ─── Close sidebar ───
  close(): void {
    this.openSubject.next(false);
    this.selectedContactSubject.next(null);
  }

  // ─── Toggle sidebar ───
  toggle(): void {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  // ─── Select a contact to show detail ───
  selectContact(contact: PhonebookContactVM | null): void {
    this.selectedContactSubject.next(contact);
  }

  // ─── Pick a contact (emits to listeners on other pages) ───
  pickContact(contact: PhonebookContactVM): void {
    this.contactPickedSubject.next(contact);
  }

  // ─── Clear the pick ───
  clearPick(): void {
    this.contactPickedSubject.next(null);
  }

  // ─── Request the "new contact" dialog from anywhere in the app ───
  requestCreate(): void {
    this.createRequestedSubject.next();
  }
}
